'use client'
import React, { useEffect, useState, useContext } from 'react'
import { Dialog } from '@headlessui/react'
import AppContext from '../../context/AppContext'
import { Elements } from '../../pages/workflow/constants'
import { toast } from 'react-toastify'

export default function FieldModal({ open, setOpen, preview, setPreview, droppedItems, setDroppedItems, dragItems, setDragItems }) {
    const [selectedField, setSelectedField] = useState(null);
    const [elements, setElements] = useState(Elements);
    const { theme,newfield, setNewfield } = useContext(AppContext);
    console.log("droppedItems", droppedItems, dragItems)
    console.log('dragItems', dragItems)
    const handleSave = () => {
        if (!selectedField) return;
        if (preview.fieldType === selectedField.fieldType) {
            toast.info("No changes made to the field type.");
            return;
        }
        if (selectedField.uniqueKey === droppedItems.find(item => item.uniqueKey === preview.uniqueKey).uniqueKey) {
            const updateItems = droppedItems.map(item => {
                if (item.uniqueKey === preview.uniqueKey) {
                    return {
                        item: {
                            ...item,
                            fieldType: selectedField.fieldType
                        }
                    }
                }
            })
            setDroppedItems(updateItems);
        }
        if (selectedField.uniqueKey === dragItems.find(item => item.uniqueKey === preview.uniqueKey).uniqueKey) {
            const updateItems = dragItems.map(item => {
                if (item.uniqueKey === preview.uniqueKey) {
                    return {
                        item: {
                            ...item,
                            fieldType: selectedField.fieldType
                        }
                    }
                }
            })
            setDragItems(updateItems);
        }
        const updatedPreview = {
            ...preview,
            fieldType: selectedField.fieldType,
        }
        setNewfield(updatedPreview)
        console.log("🆕 Updated Preview:", updatedPreview);
        console.log("🆕 Updated newfield:", newfield);

        setPreview(updatedPreview); // Triggers updates properly
        setOpen(false);
        setSelectedField(null)
    };



    return (
        <Dialog open={open} onClose={() => setOpen(false)} className="relative z-50">
            <div className="fixed inset-0 bg-black bg-opacity-25" aria-hidden="true" />
            <div className="fixed inset-0 z-50 flex items-center justify-center">
                <Dialog.Panel className="bg-white p-6 rounded shadow-xl w-full max-w-md mx-auto">
                    <Dialog.Title className="text-lg font-bold">Update Input Type</Dialog.Title>

                    <div className="flex flex-col">
                        <label className='text-gray-700 font-semibold mt-4'>
                            {preview.fieldName}
                        </label>
                        <input
                            type={preview.fieldType}
                            className="w-full rounded-md mt-3 border p-2"
                        />
                    </div>

                    <div className="flex flex-col mt-4">
                        <h4 className="text-sm font-medium mb-1">Select Input Type</h4>
                        <select
                            id="fieldDropdown"
                            className={`w-full rounded-md border p-2 text-sm text-gray-800 focus:outline-none ${theme === "dark"
                                ? "bg-gray-800 text-white"
                                : theme === "high-contrast"
                                    ? "bg-black text-white"
                                    : "bg-white"
                                }`}
                            onChange={(e) => {
                                const selected = elements.find(el => el.fieldName === e.target.value);
                                setSelectedField(selected);
                            }}
                        >
                            <option value="">-- Select Field --</option>

                            <optgroup label="Basic Fields">
                                {elements
                                    .filter(el => ["text", "email", "number", "textarea"].includes(el.fieldType))
                                    .map(el => (
                                        <option key={el.fieldName} value={el.fieldName}>
                                            {el.label || el.fieldName}
                                        </option>
                                    ))}
                            </optgroup>

                            <optgroup label="Selection Fields">
                                {elements
                                    .filter(el => ["radio", "checkbox", "select"].includes(el.fieldType))
                                    .map(el => (
                                        <option key={el.fieldName} value={el.fieldName}>
                                            {el.label || el.fieldName}
                                        </option>
                                    ))}
                            </optgroup>

                            <optgroup label="Media & Special Fields">
                                {elements
                                    .filter(el => ["file", "date", "time", "scan"].includes(el.fieldType))
                                    .map(el => (
                                        <option key={el.fieldName} value={el.fieldName}>
                                            {el.label || el.fieldName}
                                        </option>
                                    ))}
                            </optgroup>
                        </select>

                        {selectedField && (
                            <>
                                <div className="mt-4 border p-3 rounded bg-gray-50">
                                    <p className="text-sm font-semibold mb-2">Selected Field Preview:</p>
                                    <p className="text-sm text-gray-700">Field Name: {selectedField.fieldName}</p>
                                    <p className="text-sm text-gray-700">Field Type: {selectedField.fieldType}</p>
                                </div>

                            </>
                        )}
                    </div>

                    <div className="mt-6 flex justify-end space-x-2">
                        <button
                            onClick={() => setOpen(false)}
                            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            disabled={!selectedField}
                        >
                            Save
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
